import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mx-auto flex max-w-[1360px] overflow-hidden rounded-[20px] lg:justify-center',
    image: 'object-cover sm:h-60 sm:max-h-60 md:h-50 md:max-h-50',
    content:
      'absolute bottom-7 pr-5 pl-7 sm:top-1/2 sm:bottom-auto sm:left-1/2 sm:-translate-y-1/2 sm:px-0',
    advertisingInformerContent: 'top-auto bottom-7 lg:top-7 lg:bottom-auto',
    body: 'md:pl-10 lg:pt-2 lg:pl-20',
    title: 'heading-2xl lg:heading-2xl-desk mb-2 lg:mb-3',
    text: 'heading-s mb-5 lg:mb-7',
    brand: 'hidden sm:inline',
    link: 'inline-flex items-center gap-2 sm:gap-5',
    linkText: 'heading-xs-bold sm:heading-s-bold tracking-[0.06em] uppercase',
    linkIcon: 'mt-0.5',
    advertisingInformer:
      'absolute right-3 bottom-3 z-20 lg:top-3 lg:bottom-auto'
  }
});
